import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_list_check_issue_create_permissions');
	},
};
